const REQUEST_USER_NAME_SUCCESS = 'REQUEST_USER_NAME_SUCCESS';
const REQUEST_USER_NAME_FAILURE = 'REQUEST_USER_NAME_FAILURE';
const REQUEST_PROFILE_PHOTO_SUCCESS = 'REQUEST_PROFILE_PHOTO_SUCCESS';
const REQUEST_PROFILE_PHOTO_FAILURE = 'REQUEST_PROFILE_PHOTO_FAILURE';
const REQUEST_CONTACT_LIST_SUCCESS = 'REQUEST_CONTACT_LIST_SUCCESS';
const REQUEST_CONTACT_LIST_FAILURE = 'REQUEST_CONTACT_LIST_FAILURE';
const REQUEST_ACCESS_TOKEN_SUCCESS = 'REQUEST_ACCESS_TOKEN_SUCCESS';
const REQUEST_ACCESS_TOKEN_FAILURE = 'REQUEST_ACCESS_TOKEN_FAILURE';
const REQUEST_POINTS_SUCCESS = 'REQUEST_POINTS_SUCCESS';
const REQUEST_POINTS_FAILURE = 'REQUEST_POINTS_FAILURE';

export {
  REQUEST_USER_NAME_SUCCESS,
  REQUEST_USER_NAME_FAILURE,
  REQUEST_PROFILE_PHOTO_SUCCESS,
  REQUEST_PROFILE_PHOTO_FAILURE,
  REQUEST_CONTACT_LIST_SUCCESS,
  REQUEST_CONTACT_LIST_FAILURE,
  REQUEST_ACCESS_TOKEN_SUCCESS,
  REQUEST_ACCESS_TOKEN_FAILURE,
  REQUEST_POINTS_SUCCESS,
  REQUEST_POINTS_FAILURE,
};
